import { useEffect } from 'react';

import { useFormDataQuery } from '@/api/getters';
import ThankYouContactUs from '@/features/v2/hh/components/thankYou/ThankYouContactUs';
import ThankYouContactWaitingForDecision from '@/features/v2/hh/components/thankYou/ThankYouContactWaitingForDecision';
import { HHSchemaDeadEndsStepOne } from '@/features/v2/hh/stepsSchema';
import {
  getUserType,
  notQualifiedDataLayer,
} from '@/helpers/addStageToDataLyer';

const ContactUs = () => {
  // This component uses data directly from the backend (which is ensured to be the same due to revalidation)
  // instead of using the 'watch' function. This is because this component is higher in the hierarchy than the form component.
  const { data } = useFormDataQuery();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const formData = data?.payload?.data as Record<any, any>;

  const waitingForDecision =
    HHSchemaDeadEndsStepOne.noIssueReportedToInsurer.condition(formData);

  const userType = getUserType(data);

  useEffect(() => {
    if (waitingForDecision) {
      notQualifiedDataLayer('oczekiwanie_na_decyzję', 'contact_us', userType);
    } else {
      notQualifiedDataLayer('contact_us', 'contact_us', userType);
    }
  }, [waitingForDecision, userType]);

  if (waitingForDecision) {
    return <ThankYouContactWaitingForDecision />;
  }

  return <ThankYouContactUs />;
};

export default ContactUs;
